<template>
  <div
    id="context-menu-message"
    class="context-menu"
    @mouseleave="$emit('hideMenu')">
    <span>
      <!-- <div v-if="isShowFull">
        <div class="context-menu-item">
          <span class="font-13 text-grey600">Chọn nhiều</span>
        </div>
        <el-divider class="m-0 p-0" />
      </div> -->

      <div
        v-if="message.msgType !== 'chat.recommended'"
        @click="forwardMessage"
        class="context-menu-item">
        <span class="font-13 text-grey600">Chuyển tiếp</span>
      </div>

      <div
        v-if="message.msgType === 'chat.photo' || message.msgType === 'chat.video.msg'"
        @click="downloadMessage"
        class="context-menu-item">
        <span class="font-13 text-grey600">Tải xuống</span>
      </div>
      <!-- <div class="context-menu-item">
        <span class="font-13 text-grey600">Lưu vào thư viện</span>
      </div> -->
      <!-- <div class="context-menu-item">
        <span class="font-13 text-grey600">Xem tin nhắn gốc</span>
      </div> -->
      <el-divider class="m-0 p-0" />
      <div
        @click="deleteMessage"
        class="context-menu-item">
        <span class="font-13 text-red500">Xóa tin nhắn</span>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  props: ["message", "conversation", "profile", "members", "isShowFull"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    downloadMessage() {
      let url = JSON.parse(this.message.content).href;
      this.download(url);
      this.alert("success", "Tải ảnh về thành công!");
      return;
    },
    download(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = url;
          document.body.appendChild(link);
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
    },
    forwardMessage() {
      this.$bus.$emit("forwardMessage", this.message);
    },
    deleteMessage() {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: this.conversation.group,
        cliMsgId: this.message.cliMsgId,
        globalMsgId: this.message.id.msgId,
        ownerId: this.conversation.toId,
        destId: this.conversation.toId,
      };
      this.$http.post("/api/message/delete", request);
    },
  },
};
</script>

<style scoped>
.context-menu {
  position: fixed;
  background-color: #fff;
  border: thin solid #f5f6f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  cursor: pointer;
}

.context-menu div {
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
}

.context-menu-item {
  display: flex;
  align-items: center;
}

.context-menu-item:hover {
  color: var(--el-color-primary);
  background-color: #e8f0fb;
}
</style>